define('controller/people/external.associations.list.controller',['require','exports','module','fukit/fukit','view/people/external.associations.list.page.view','model/external.association.model','model/person.model','fukit/fukit','underscore','backbone.radio'],function(require, exports, module) {
  // prettier-ignore
  var BaseController               = require('fukit/fukit').BaseController,
      ExternalAssociationsListView = require('view/people/external.associations.list.page.view'),
      ExternalAssociationsModel    = require('model/external.association.model'),
      PersonModel                  = require('model/person.model'),
      RouteHelper                  = require('fukit/fukit').RouteHelper,
      has                          = require('underscore').has,
      Radio                        = require('backbone.radio');

  var ExternalAssociationsListController = BaseController.extend({
    radioRequests: {
      'controllers ExternalAssociationsListController': '@constructor',
    },

    pageView: ExternalAssociationsListView,

    resources: {
      person: {
        model: PersonModel,
      },
      currentPersonCollection: {
        collection: PersonModel.Collection,
      },
      externalAssociations: {
        collection: ExternalAssociationsModel.Collection,
      },
    },

    onStart: function() {
      var userPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');
      var currentPersonCollection = this.getResource('currentPersonCollection');
      var personModel = this.getResource('person');

      if (has(userPrincipalModel, 'id')) {
        currentPersonCollection.filters.addFilterWithField({ name: 'userAccountId' }).equals(userPrincipalModel.id);
        currentPersonCollection
          .fetch()
          .promise()
          .then(function() {
            if (currentPersonCollection.length === 0) {
              return;
            }

            personModel.set(currentPersonCollection.models[0].toJSON());
          });
      }

      var externalAssociations = this.getResource('externalAssociations');

      externalAssociations
        .fetch()
        // TODO: when person-service is updated to send the correct href
        //  for _links.self, remove this
        .promise()
        .then(function() {
          externalAssociations.models.forEach(function(model) {
            model.getLink('self').set('href', model.urlRootTemplate + '/' + model.get('id'));
          });
        });
    },
  });

  module.exports = ExternalAssociationsListController;
});

